import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { DashboardSidebarComponent } from '../sidebar/dashboard-sidebar.component';
import { DashboardTopbarComponent } from '../topbar/dashboard-topbar.component';
import { ContactCandidateDialogComponent } from '@app/modules/chat/components/contact-candidate-dialog/contact-candidate-dialog.component';
import { CvService } from '@app/modules/candidate/cv/services/cv.service';
import { AuthService } from '@app/modules/auth/services/auth.service';

@Component({
  standalone: true,
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    DrawerModule,
    ButtonModule,
    TranslocoModule,
    DashboardSidebarComponent,
    DashboardTopbarComponent,
    ContactCandidateDialogComponent
  ]
})
export class DashboardLayoutComponent implements OnInit, OnDestroy {
  private readonly cvService = inject(CvService);
  private readonly authService = inject(AuthService);

  sidebarVisible = false;
  sidebarCollapsed = false;
  isMobile = false;
  /** Fallback na ogólny podtytuł, dopóki nie znamy typu konta użytkownika */
  brandSubtitleKey = 'layout.sidebar.brandSubtitle';

  private resizeHandler = () => this.checkScreenSize();

  constructor() {
    this.authService.currentUser$
      .pipe(takeUntilDestroyed())
      .subscribe(user => {
        if (user) {
          this.brandSubtitleKey = user.isCompany
            ? 'layout.sidebar.brandSubtitleCompany'
            : 'layout.sidebar.brandSubtitleCandidate';
        }
      });
  }

  ngOnInit() {
    this.checkScreenSize();
    window.addEventListener('resize', this.resizeHandler);

    // Load CV completeness only for candidates — not relevant for company accounts
    const user = this.authService.currentUser$.value;
    if (user?.isCandidate) {
      this.cvService.loadCompleteness().subscribe();
    }
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth < 992;
    if (!this.isMobile) {
      this.sidebarVisible = false;
    }
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  toggleSidebarCollapse(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  onSidebarHide(): void {
    this.sidebarVisible = false;
  }
}
